// extracted by mini-css-extract-plugin
module.exports = {"Main":"Button-module--Main--1oARH"};